export default __webpack_public_path__ + "static/media/xx99-mark-ii-in-person.78b9c6a9.png";